export interface JsonResponseLike {
  ok: boolean;
  status: number;
  statusText?: string;
  json: () => Promise<any>;
}

export async function parseRequiredJsonResponse<T = any>(
  response: JsonResponseLike,
  fallback: string
): Promise<T> {
  let data: any;
  try {
    data = await response.json();
  } catch {
    const statusSuffix = response.status
      ? ` (${response.status}${
          response.statusText ? ` ${response.statusText}` : ""
        })`
      : "";
    throw new Error(`${fallback}${statusSuffix}: invalid JSON response`);
  }

  if (!response.ok) {
    const serverMessage = data?.message || data?.error || null;
    const statusSuffix = response.status
      ? ` (${response.status}${
          response.statusText ? ` ${response.statusText}` : ""
        })`
      : "";
    throw new Error(serverMessage || `${fallback}${statusSuffix}`);
  }

  return data as T;
}

export async function ensureOkResponse(
  response: JsonResponseLike,
  fallback: string
): Promise<void> {
  if (response.ok) return;

  let data: any = null;
  try {
    data = await response.json();
  } catch {
    // Preserve a useful HTTP fallback when an error response has no JSON body.
  }

  const serverMessage = data?.message || data?.error || null;
  const statusSuffix = response.status
    ? ` (${response.status}${
        response.statusText ? ` ${response.statusText}` : ""
      })`
    : "";
  throw new Error(serverMessage || `${fallback}${statusSuffix}`);
}
